import React from 'react';

function CardIcon6() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      fill="none"
      viewBox="0 0 38 25"
    >
      <g clipPath="url(#clip0_2_8256)">
        <path
          fill="#000"
          d="M35 .6H3c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
          opacity="0.07"
        ></path>
        <path
          fill="#D64D00"
          d="M35 1.6c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32z"
        ></path>
        <path
          fill="#FF8A00"
          d="M18.093 12.576v3.2h-1.018v-7.9h2.691a2.447 2.447 0 011.747.692 2.28 2.28 0 01.11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698a1.348 1.348 0 001.37-1.117 1.39 1.39 0 00-1.37-1.64l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.65v3.333h-.969v-.766h-.049a1.93 1.93 0 01-1.673.931 2.17 2.17 0 01-1.496-.533 1.667 1.667 0 01-.613-1.324 1.607 1.607 0 01.613-1.336 2.746 2.746 0 011.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.133 1.133 0 00-.417-.9 1.416 1.416 0 00-.98-.369 1.545 1.545 0 00-1.319.717l-.895-.564a2.488 2.488 0 012.182-1.06zM23.29 14.12a.791.791 0 00.337.662c.223.176.5.27.785.263.429 0 .84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 00-1.324-.374 1.716 1.716 0 00-1.03.294.882.882 0 00-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097zM13.986 11.884c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.095 2.095 0 01-.9 1.373v1.134h1.464a4.434 4.434 0 001.348-3.334z"
        ></path>
        <path
          fill="#FF8A00"
          d="M9.629 16.321a4.352 4.352 0 003.01-1.097l-1.466-1.14a2.753 2.753 0 01-4.094-1.44H5.577v1.17a4.53 4.53 0 004.052 2.507z"
        ></path>
        <path
          fill="#FF8A00"
          d="M7.079 12.65a2.71 2.71 0 010-1.735v-1.17H5.577a4.505 4.505 0 000 4.075l1.502-1.17z"
        ></path>
        <path
          fill="#FF8A00"
          d="M9.629 9.04a2.452 2.452 0 011.74.68l1.3-1.293a4.37 4.37 0 00-3.065-1.183 4.53 4.53 0 00-4.027 2.5l1.502 1.171a2.715 2.715 0 012.55-1.875z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_8256">
          <path
            fill="#fff"
            d="M0 0H38V24H0z"
            transform="translate(0 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon6;
